<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="供应商退货" name="op">
			<div class="content-box">
				<edit-returned></edit-returned>
			</div>
		</el-tab-pane>
		<el-tab-pane label="退货记录" name="his">
			<his v-if="activeName=='his'" :type="[23]"></his>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import His from "@/views/Inventory/subs/His.vue";
import EditReturned from "@/views/Inventory/subs/EditReturned";

export default {
	mixins: [TabPage],
	components: {
		His,
		EditReturned
	},
	data() {
		return {
			activeName: "op"
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
